import {
  Checkbox,
  DatePicker,
  Icon,
  InputDropdown,
  NewTable,
  SearchBar,
  Section,
  useToast,
} from '@vallourec-ui/vallourec-ui'
import React, { useCallback, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { generateReport as generateReportPost } from '@/api/post'

import { useGenerateReport } from '@/stores/GenerateReportStore'

import {
  ButtonContainer,
  Row,
  StyledButton,
  StyledTextButton,
  ContentContainer,
  TableWrapper,
  StickyTd,
} from './style'
import { template } from './template'
import { DataResultTemplate } from '@/@types/global'
import { useApp } from '@/stores/AppStore'
import { useDocumentApproval } from '@/stores/DocumentApprovalStore'

const DataToResult: React.FC = () => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const { setIsLoading, templateColumn, resultItems, setExecuteSearch, user } =
    useApp()
  const {
    templateColumnResult,
    setTemplateColumnResult,
    templateRowResult,
    setTemplateRowResult,
  } = useDocumentApproval()

  useEffect(() => {
    // if(!templateColumnResult || templateColumnResult.length === 0){
    const columns = template.map((elem) => {
      return {
        id: elem.id,
        accessorKey: elem.id,
        header: t(elem.header),
        width: elem.width,
        cell: ({ cell }) => {
          return <div style={{ width: elem.width }}>{cell.getValue()}</div>
        },
      } as DataResultTemplate
    })
    setTemplateColumnResult(columns)
    // }
  }, [])

  const renderTable = useCallback(() => {
    return (
      <TableWrapper>
        <StickyTd>
          <NewTable.Root
            key="Table-with-result"
            columnIdWithRowspan="button"
            columns={templateColumnResult ?? []}
            data={templateRowResult ?? []}
            hasPagination
            isBordered
            hasScroll
          />
          <Row
            style={{
              justifyContent: 'flex-end',
              marginTop: '2px',
              marginBottom: '2px',
            }}
          />
        </StickyTd>
      </TableWrapper>
    )
  }, [templateColumnResult, templateRowResult, t])

  return <ContentContainer>{renderTable()}</ContentContainer>
}

export default DataToResult
